export default __webpack_public_path__ + "static/media/backcard_icare.f2251df0.png";